<template>
  <div class="ui container">
    <img
      class="ui centered small image"
      :src="api_host + '/' + organization_configuration.logo.relative_path"
      v-if="organization_configuration && organization_configuration.logo"
    />
    <div v-if="is_expired">
      <h2 class="ui center aligned icon header">
        <i class="circular orange calendar icon"></i>
        <div class="content">
          {{ $t("this survey has already expired") }}
          <!-- <div class="sub header">                
              </div> -->
        </div>
      </h2>
    </div>
    <div v-if="is_finished">
      <h2 class="ui center aligned icon header">
        <i class="circular green check icon"></i>
        <div class="content">
          {{ $t("this survey has been responded already") }}
          <!-- <div class="sub header">                
              </div> -->
        </div>
      </h2>
    </div>
    <div v-if="!is_finished && !is_expired">
      <h3 class="ui centered header">
        <div class="content">
          {{ $t("feedback 360 survey") }}
          <div class="sub header">
            <!-- <strong>{{ $t("evaluated user") }}</strong>
            {{ srvy.evaluated_user.name }} <strong>{{ $t("survey") }}</strong> -->
            {{ srvy.staff_rating_evaluation.evaluated_user.name }} -
            {{ srvy.staff_rating_evaluation.staff_rating_template.name }} -
            {{ translate_reason(srvy.reason) }}
          </div>
        </div>
      </h3>
      <div class="ui shape" ref="sides">
        <div class="sides">
          <div class="active side">
            <form-wizard
              title=""
              subtitle=""
              :nextButtonText="$t('next')"
              :backButtonText="$t('back')"
              :finishButtonText="$t('finish')"
              shape="circle"
              @on-complete="onComplete"
              @on-change="onChange"
            >
              <tab-content
                icon="check icon"
                :title="$t('question') + ' ' + (qidx + 1)"
                v-for="(qstn, qidx) in items"
                :key="qidx"
                :before-change="qstn.validateFunction"
                stepCheckedStyle="red"
              >
                <question
                  :question="qstn"
                  @set_answer="set_answer"
                  :responses="responses"
                />
              </tab-content>
            </form-wizard>
          </div>
          <div class="side">
            <h2 class="ui center aligned icon header">
              <i class="circular green check icon"></i>
              <div class="content">
                {{ $t("thank you, it's done!") }}
                <!-- <div class="sub header">                
              </div> -->
              </div>
            </h2>
          </div>
        </div>
      </div>
      <div class="ui list" v-if="show_responses && responses.length > 0">
        <h4 class="ui header">
          <i class="green check icon"></i> {{ $t("your responses") }}
        </h4>
        <div class="item" v-for="(rspns, ridx) in responses" :key="ridx">
          <i class="check middle aligned icon"></i>
          <div class="content">
            <a class="header">{{ rspns.aspect.prompt }}</a>
            <div class="description">{{ rspns.answer.prompt }}</div>
          </div>
        </div>
      </div>
      <!-- <pre>{{ srvy }}</pre> -->
      <!-- <pre>{{ responses }}</pre> -->
    </div>
  </div>
</template>

<script>
import filters from "@/filters";
import { local_api, error_toast, warning_toast, api_host } from "@/utils";
import { FormWizard, TabContent } from "vue-form-wizard";
import Question from "./Question.vue";
import { cloneDeep } from "lodash";
import moment from "moment";

export default {
  name: "StaffRating360EvaluationRun",
  components: { FormWizard, TabContent, Question },
  filters: filters,
  computed: {
    api_host() {
      return api_host;
    },
    items() {
      let vm = this;
      let questns =
        vm.srvy.staff_rating_evaluation.staff_rating_template.setup.items || [];

      /** items are ordered */
      questns = questns
        .sort((a, b) => {
          {
            if (Number(a.order || 0) > Number(b.order || 0)) return 1;
            else if (Number(a.order || 0) < Number(b.order || 0)) return -1;
            else return 0;
          }
        })
        .map((q) => {
          q.validateFunction = function() {
            return new Promise((resolve, reject) => {
              // console.log("validate question", q);

              /** Check steps */

              if (q.mandatory) {
                let questionResponses = vm.responses.filter((rsp) => {
                  return rsp.aspect.uuid == q.uuid;
                });

                if (questionResponses.length) resolve(true);
                else {
                  warning_toast(
                    vm.$t(
                      "this question is mandatory, please answer it in order to continue",
                    ),
                  );
                  reject();
                }
              } else resolve(true);

              // let x = true;
              // if (x) resolve(true);
              // else reject();
            });
          };
          return q;
        });
      return questns;
    },
  },
  data() {
    return {
      srvy: {
        staff_rating_evaluation: {
          staff_rating_template: {
            setup: { items: [] },
          },
          evaluated_user: { name: "" },
          evaluating_user: { name: "" },
        },
      },
      responses: [],
      is_finished: false,
      is_expired: false,
      show_responses: true,
      organization_configuration: {},
    };
  },
  methods: {
    translate_reason(reason) {
      let vm = this;
      switch (reason) {
        case "superior_evaluation":
          return vm.$t("superior survey");
        case "inferior_evaluation":
          return vm.$t("inferior survey");
        case "same_level_evaluation":
          return vm.$t("same level survey");
        case "auto_evaluation":
          return vm.$t("auto survey");
        default:
          return reason;
      }
    },
    load(uuid) {
      let vm = this;
      local_api(vm, "post", "/staff_rating/360_evaluation_run/do-get", {
        u: uuid,
      })
        .then((r) => {
          vm.srvy = r;

          /** Check for expiration */
          let limit_date = moment(r.create_date).add(
            vm.organization_configuration.expire_time,
            vm.organization_configuration.expire_time_unit,
          );
          let now = moment();
          if (now > limit_date) {
            vm.is_expired = true;
          }
        })
        .catch((err) => {
          if (err == "EVALUATION FINISHED") {
            vm.is_finished = true;
          } else error_toast(err);
        });
    },
    onComplete: function() {
      let vm = this;

      /** Check for max unevaluated aspects */
      let totalAspects =
        vm.srvy.staff_rating_evaluation.staff_rating_template.setup.items
          .length;
      let evaluatedAspects = vm.responses.map((r) => {
        return r.aspect.uuid;
      }).length;
      let difference = totalAspects - evaluatedAspects;
      // console.log("difference", difference);
      if (
        difference <=
        Number(
          vm.srvy.staff_rating_evaluation.staff_rating_template.setup
            .max_unevaluated,
        )
      ) {
        let uuid = vm.$route.query.u;
        // console.log("respond", uuid);
        local_api(vm, "post", "/staff_rating/360_evaluation_run/do-respond", {
          u: uuid,
          r: vm.responses,
        })
          .then(() => {
            window.jQuery(vm.$refs.sides).shape("flip back");
            vm.show_responses = false;
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        warning_toast(
          `${vm.$t("you have")} ${difference} ${vm.$t(
            "unevaluated aspects, the maximum is",
          )} ${
            vm.srvy.staff_rating_evaluation.staff_rating_template.setup
              .max_unevaluated
          }`,
        );
      }
    },
    // validateTab: function(question) {
    //   console.log("validateTab", question);
    //   return true;
    // },
    set_answer(question, answer) {
      let vm = this;

      /** Array method */
      let qstn = cloneDeep(question);
      delete qstn.answers;
      delete qstn.validateFunction;
      let rspnsIndx = vm.responses.findIndex((r) => {
        return r.aspect.uuid == qstn.uuid && r.answer.uuid == answer.uuid;
      });
      if (rspnsIndx > -1) {
        vm.responses.splice(rspnsIndx, 1);
      } else if (rspnsIndx == -1) {
        /** If is only one answer allowed */
        if (question.max_answers == 1) {
          /** Remove previous answer */
          let trgtIdx = vm.responses.findIndex((rs) => {
            return rs.aspect.uuid == question.uuid;
          });
          // console.log("trgtIdx", trgtIdx);
          if (trgtIdx >= 0) vm.responses.splice(trgtIdx, 1);
        }

        let questionAnswers = vm.responses.filter((r) => {
          return r.aspect.uuid == qstn.uuid;
        });
        // console.log("hre");
        if (qstn.max_answers > questionAnswers.length) {
          vm.responses.push({
            aspect: {
              uuid: qstn.uuid,
              prompt: qstn.prompt,
              category_id: qstn.category_id,
            },
            answer: {
              uuid: answer.uuid,
              prompt: answer.prompt,
              weight: answer.weight,
            },
          });
        }
      }
    },
    is_answered(question) {
      let vm = this;
      let exists = vm.responses.find((rr) => {
        return rr.aspect.uuid == question.uuid;
      });
      if (exists) return true;
      else return false;
    },
    onChange(/* prevIndex, nextIndex */) {
      let vm = this;
      vm.items.map((itm, idx) => {
        let trgtStep = window.jQuery(".wizard-nav .wizard-icon-circle")[idx];
        let isAnswered = vm.is_answered(itm);
        if (isAnswered) {
          window
            .jQuery(trgtStep)
            .css(
              "background-color",
              `#${vm.organization_configuration.step_mark_color}`,
            );
          window
            .jQuery(trgtStep)
            .css(
              "border-color",
              `#${vm.organization_configuration.step_mark_color}`,
            );
        } else {
          window.jQuery(trgtStep).removeAttr("style");
          // window.jQuery(trgtStep).css("border-color", "purple");
        }

        // console.log("trgtStep: ", trgtStep);
      });
      // console.log("nextIndex: ", nextIndex);

      // let trgtIconContainer = window
      //   .jQuery(trgtStep)
      //   .find(".wizard-icon-container")[0];
      // let trgtItem = vm.items[prevIndex];
      // window
      //   .jQuery(trgtIconContainer)
      //   .css("background-color", vm.organization_configuration.step_mark_color);
      // console.log("trgtIconContainer: ", trgtIconContainer);
      // console.log("trgtItem: ", trgtItem);
    },
  },
  mounted() {
    let vm = this;

    /** Get configuration */
    local_api(vm, "post", "/staff_rating/organization/do-get-configuration", {})
      .then((configuration) => {
        if (configuration) {
          vm.organization_configuration = configuration;

          if (configuration.step_button_color) {
            var css1 = document.createElement("style");
            css1.type = "text/css";
            var styles1 = `.wizard-card-footer button { border-color: #${configuration.step_button_color} !important }`;
            styles1 += `.wizard-card-footer button { background-color: #${configuration.step_button_color} !important }`;
            if (css1.styleSheet) css1.styleSheet.cssText = styles1;
            else css1.appendChild(document.createTextNode(styles1));
            document.getElementsByTagName("head")[0].appendChild(css1);
          }
          if (configuration.step_mark_color) {
            var css2 = document.createElement("style");
            css2.type = "text/css";
            var styles2 = `.wizard-nav div[role=tab] { border-color: #${configuration.step_mark_color} !important }`;
            styles2 += `.wizard-nav div[role=tab] div.wizard-icon-container { background-color: #${configuration.step_mark_color} !important }`;
            styles2 += `.wizard-progress-bar { background-color: #${configuration.step_mark_color} !important; color: #${configuration.step_mark_color} !important }`;
            styles2 += `.wizard-nav .stepTitle.active { color: #${configuration.step_mark_color} !important }`;
            if (css2.styleSheet) css2.styleSheet.cssText = styles2;
            else css2.appendChild(document.createTextNode(styles2));
            document.getElementsByTagName("head")[0].appendChild(css2);
          }
        } else {
          warning_toast(vm.$t("configuration not set yet"));
        }
        // console.log(configuration);

        let uuid = vm.$route.query.u;
        if (uuid) vm.load(uuid);
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
};
</script>

<style></style>
